// Suppress benign Firestore gRPC idle stream disconnect warnings/errors
const shouldSuppress = (message: string): boolean => {
  const lower = message.toLowerCase();
  return (
    lower.includes('disconnecting idle stream') ||
    lower.includes('timed out waiting for new targets') ||
    lower.includes('grpcconnection') ||
    lower.includes('cancelled') ||
    lower.includes('listen') ||
    lower.includes('firebase/firestore')
  );
};

const formatArg = (arg: any): string => {
  if (arg instanceof Error) {
    return arg.message + ' ' + (arg.stack || '');
  }
  if (typeof arg === 'object' && arg !== null) {
    try {
      return JSON.stringify(arg);
    } catch {
      return String(arg);
    }
  }
  return String(arg);
};

const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  const message = args.map(formatArg).join(' ');
  if (shouldSuppress(message)) {
    return;
  }
  originalConsoleError(...args);
};

const originalConsoleWarn = console.warn;
console.warn = (...args: any[]) => {
  const message = args.map(formatArg).join(' ');
  if (shouldSuppress(message)) {
    return;
  }
  originalConsoleWarn(...args);
};

const originalConsoleLog = console.log;
console.log = (...args: any[]) => {
  const message = args.map(formatArg).join(' ');
  if (shouldSuppress(message)) {
    return;
  }
  originalConsoleLog(...args);
};

const originalConsoleInfo = console.info;
console.info = (...args: any[]) => {
  const message = args.map(formatArg).join(' ');
  if (shouldSuppress(message)) {
    return;
  }
  originalConsoleInfo(...args);
};

const originalConsoleDebug = console.debug;
console.debug = (...args: any[]) => {
  const message = args.map(formatArg).join(' ');
  if (shouldSuppress(message)) {
    return;
  }
  originalConsoleDebug(...args);
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (event.message && shouldSuppress(event.message)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const msg = reason instanceof Error ? reason.message : String(reason);
    if (shouldSuppress(msg)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
}
